export default "__VITE_ASSET__Lez6cfum__"